module.exports = __webpack_public_path__ + "static/media/IMG_1275.8bb51325.JPG";